var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"settings\">\n<div class=\"btn-group\">\n<button ui-sref=\"settings.clusters\" ui-sref-active=\"active\" class=\"btn btn-primary\">Clusters</button>\n<button ui-sref=\"settings.profile\" ui-sref-active=\"active\" class=\"btn btn-primary\">Profile</button>\n</div>\n<div ui-view></div>\n</div>";
var id1="containers/settings/settings.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/settings/settings.view.html
// module id = 812
// module chunks = 0